import request from './request'

// 获取投注记录详情
export const getDetailRecordList = (params) =>
  request({
    url: '/carbon-game/private/user/game/record/page/code',
    method: 'GET',
    params,
  })
//获取账变记录
export const getWalletFlowList = (params) =>
  request({
    url: '/carbon-wallet/private/user/wallet/flow/page',
    method: 'GET',
    params,
  })
//账变记录统计
export const getWalletFlowSummary = (params) =>
  request({
    url: '/carbon-wallet/private/user/wallet/flow/count',
    method: 'GET',
    params,
  })
// 获取游戏投注记录统计
export const getRecordCount = (params) =>
  request({
    url: '/carbon-game/private/user/game/record/sum/bg',
    method: 'GET',
    params,
  })
// 获取游戏投注记录列表
export const getRecordList = (params) =>
  request({
    url: '/carbon-game/private/user/game/record/page/bg',
    method: 'GET',
    params,
  })
